module.exports = __webpack_public_path__ + "images/poker-9b5c736f6cded8f36805954f92cd801e.png";